import { Controller } from "@hotwired/stimulus"
import { useClickOutside } from "../helpers/click_outside_mixin"

// Generic Bulma dropdown toggle (is-active on host element).
export default class extends Controller {
  static targets = [ "trigger" ]

  connect() {
    this._clickOutside = useClickOutside(this.element, () => {
      this.setOpen(false)
    })
  }

  disconnect() {
    this._clickOutside?.remove()
  }

  toggle(event) {
    event.preventDefault()
    const open = !this.element.classList.contains("is-active")
    this.setOpen(open)
  }

  setOpen(open) {
    this.element.classList.toggle("is-active", open)
    if (this.hasTriggerTarget) {
      this.triggerTarget.setAttribute("aria-expanded", open ? "true" : "false")
    }
    if (open) {
      this._clickOutside.add()
    } else {
      this._clickOutside.remove()
    }
  }
}
